import { API } from "../helpers";
import { SERVER_URL } from "../config";

export function getTeam(authToken, data) {
  return API.request({
    method: "post",
    url: `${SERVER_URL}/api/v1/partners/teams`,
    headers: {
      authentication_token: authToken,
    },
    data,
  });
}

export function searchTeamMembers(authToken, params) {
  return API.request({
    method: "get",
    url: `${SERVER_URL}/api/v1/partners/teams/members_list`,
    headers: {
      authentication_token: authToken,
    },
    params,
  });
}

export function bulkRequest(authToken, data) {
  return API.request({
    method: "post",
    url: `${SERVER_URL}/api/v1/partners/teams/team_bulk_operation`,
    headers: {
      authentication_token: authToken,
    },
    data,
  });
}

export function getTeamMember(authToken, id) {
  return API.request({
    method: "get",
    url: `${SERVER_URL}/api/v1/partners/users/${id}`,
    headers: {
      authentication_token: authToken,
    },
  });
}

export function createTeamMember(authToken, data) {
  return API.request({
    method: "post",
    url: `${SERVER_URL}/api/v1/partners/users/create_member`,
    headers: {
      authentication_token: authToken,
    },
    data,
  });
}

// Records a colleague as school staff so they can be picked as a visit
// organiser. Unlike createTeamMember this sends no invite email — the
// counselor is writing down a name while scheduling a visit, not onboarding
// someone. See Api::V1::Teams::CreateOrganizer.
export function createOrganizer(authToken, data) {
  return API.request({
    method: "post",
    url: `${SERVER_URL}/api/v1/partners/teams/create_organizer`,
    headers: {
      authentication_token: authToken,
    },
    data,
  });
}

export function updateTeamMember(authToken, id, data) {
  return API.request({
    method: "put",
    url: `${SERVER_URL}/api/v1/partners/users/${id}/update_member`,
    headers: {
      authentication_token: authToken,
      "Content-Type": "multipart/form-data",
    },
    data,
  });
}
